export default function confirmBrowserQuit (message, destroyConfirmation) {
    if (destroyConfirmation) {
        window.onbeforeunload = null
    } else {
        window.onbeforeunload = function (e) {
            // Cancel the event
            e.preventDefault()
            // Chrome requires returnValue to be set
            e.returnValue = message
        }
    }
}


// WEBPACK FOOTER //
// ./src/helpers/confirm-browser-quit.js